import initState from './initState';

export default {
  clearlogin(state, data){
    const initial = initState();
    Object.keys(initial).forEach((key) => {
      state[key] = initial[key];
    });
  },
  loginalready(state, data){
    state.user.loginalready = data;
  },
  setReportId(state, data) {
    state.report[data.key] = data.value;
  },
  setTypeOfBusiness(state, data) {
    state.typeOfBusiness = data;
  },
  setTypeOfBusinessConst(state, data) {
    state.typeOfBusinessConst = data;
  },
  setUser(state, data) {
    state.user = data;
  },
  updateUser(state, data) {
    state.user[data.key] = data.value;
  },
  seedetailservice(state, data) {
    state.seedetailservice = data;
  },
  profilemenumargin(state, data) {
    state.profilemenumargin = data;
  },
  checkToken(state,data){
    state.checkToken = data
  },
  setOpenModalCreate(state,data){
    state.isOpenModalCreate = data
  }
};



// WEBPACK FOOTER //
// ./src/store/mutations.js